import { OrganizationTableItem } from 'types/organizations_table'

export const determineSeoTier = (products: OrganizationTableItem[]) => {
  const seoTier = products.reduce((acc, product) => {
    switch (product.productName) {
      case 'SEO - Tier 1':
        return 1
      case 'SEO - Tier 2':
        return 2
      case 'SEO - Tier 3':
        return 3
      case 'SEO - Tier 4':
        return 4
      default:
        return acc
    }
  }, 0)
  return seoTier
}
